import { useEffect, useState } from 'react'

/**
 * Detecta a altura total dos elementos que casam com `selectors` e retorna
 * o offset (px) que outro banner deve usar pra ficar empilhado acima deles.
 *
 * Usado pra empilhar EnvBadge, ImpersonationBanner e GodModeBanner no canto
 * inferior direito sem sobreposição. Cada banner detecta os "anteriores" no
 * stack e calcula seu próprio bottom dinamicamente.
 *
 * `selectors` aceita string única ou array — útil quando um banner precisa
 * empilhar acima de mais de um elemento (ex: GodMode acima de EnvBadge +
 * ImpersonationBanner, embora na prática Impersonation/GodMode são mutex).
 */
export function useStackAbove(selectors: string | string[], gap = 8): number {
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    const list = Array.isArray(selectors) ? selectors : [selectors]
    const detect = () => {
      let total = 0
      for (const sel of list) {
        const el = document.querySelector(sel) as HTMLElement | null
        if (!el) continue
        total += Math.ceil(el.getBoundingClientRect().height) + gap
      }
      setOffset(total)
    }
    detect()
    const obs = new MutationObserver(detect)
    obs.observe(document.body, { childList: true, subtree: true, attributes: true })
    window.addEventListener('resize', detect)
    return () => { obs.disconnect(); window.removeEventListener('resize', detect) }
  }, [selectors, gap])

  return offset
}
